import * as React from 'react';

import {colors} from '../colors/colors';
import {HoverPopover} from '../hover-popover/hover-popover';
import {LeadIconChevron} from '../icon/svg/lead-icon-chevron';
import type {Lead} from '../timeline/types';

import {PopoverContent} from './popover-content';

import styles from './lead-count-avatar.module.css';

type Props = {
    leads: Lead[];
    size: number;
};

export function LeadCountAvatar(props: Props) {
    const {leads, size} = props;

    const anchor = React.useRef(null);

    return (
        <>
            <div
                ref={anchor}
                style={{width: size, height: size, borderRadius: size}}
                className={styles['lead-chevron-container']}
            >
                <LeadIconChevron
                    wrapWithDiv={false}
                    size={Math.ceil(size / 1.4)}
                    // @ts-expect-error
                    fill={colors.white}
                />
                <div
                    style={{width: size, height: size, fontSize: Math.ceil(size / 2.6)}}
                    className={styles['count-container']}
                >
                    <div>{leads.length}</div>
                </div>
            </div>
            {/* @ts-expect-error */}
            <HoverPopover anchorRef={anchor} location='bottom' disableFocusTrapZone={true}>
                <PopoverContent leads={leads} />
            </HoverPopover>
        </>
    );
}
